// 1. IMPORTS
import Request from "./request";
import { removeEmptyValues } from "helper/UtilsFunctionsObject";

// 4. API CALLS
class PaymentMethodTypeServiceAPI {
  static async getListPaymentMethodType(data) {
    const response = await Request.send({
      method: "POST",
      path: "/PaymentMethodType/advanceUser/getList",
      data: removeEmptyValues(data),
    });
    if (response?.statusCode !== 200) {
      throw new Error(response?.message || "Không lấy được loại thanh toán");
    }
    return response.data;
  }
}

// 9. EXPORTS
export default PaymentMethodTypeServiceAPI;